<template>
    <div class="categories-list uppercase text-white text-xs flex flex-col tablet:flex-row tablet:items-center">
        <!--List Title-->
        <div
            class="category-name mb-2 mr-3"
            v-text="listTitle" />
        <!--Category List Iterator-->
        <div class="flex flex-row flex-wrap">
            <tis-button
                v-for="(category, index) in postCategories"
                :key="index"
                :class="{'border-gold-500 text-gold-500': category.slug === currentCategory}"
                :url="category.url"
                class="category-name border rounded-sm border-white p-3 mr-2 mb-2 hover:border-gold-500 hover:text-gold-500 transition-all"
                v-html="category.label"
            />
        </div>
    </div>
</template>

<script>
import TisButton from '@whisper/components/buttons/TisButton';

export default {
  name: 'ListPostCategories',
  components: { TisButton },
  props: {
    currentCategory: {
      type: String,
      required: true,
    },
    listTitle: {
      type: String,
      required: false,
    },
    postCategories: {
      type: Object,
      required: true,
    },
  },
};
</script>
